const STATUS_ICON_MAP: Record<string, string> = {
    Draft: 'cn-icon-ico-draft',
    Incomplete: 'cn-icon-ico-draft',
    Valid: 'cn-icon-ico-valid',
    Active: 'cn-icon-ico-valid',
    Shipping: 'cn-icon-ico-shipping',
    Shipped: 'cn-icon-ico-ready-to-dispatch',
    Completed: 'cn-icon-ico-flag-checked',
    ActionRequired: 'cn-icon-ico-megaphone1',
    Cancelled: 'cn-icon-ico-delete',
    Canceled: 'cn-icon-ico-cancel',
    Blocked: 'cn-icon-ico-flag-blocked',
    Deleted: 'cn-icon-ico-delete',
    OnHold: '',
    InProgress: '',
    Released: 'cn-icon-ico-confirm',
    Open: 'cn-icon-ico-megaphone1',
    Resolved: 'cn-icon-ico-confirm',
    Deferred: 'cn-icon-ico-flag-waiting',
    Normal: '',
    Low: 'cn-icon-ico-flag-warning-low',
    High: 'cn-icon-ico-flag-warning-high',
    Confirmed: 'cn-icon-ico-confirmed',
    Planned: 'cn-icon-ico-calendar2',
    Posted: 'cn-icon-ico-confirm1',
    InProduction: 'cn-icon-ico-in_production',
    ReadyForDelivery: 'cn-icon-ico-ready-for-delivery',
    Delivered: 'cn-icon-ico-delivered',
    Invoiced: 'cn-icon-ico-invoice',
    Invoice: 'cn-icon-ico-invoice',
    Cancellation: 'cn-icon-ico-cancel',
    Attention: 'cn-icon-ico-attention',
};

export function getStatusIndicatorClass(status: string | null | undefined): string {
    return status ? `status-indicator-${status}` : 'status-indicator-Normal';
}

export function getStatusIconClass(status: string | null | undefined, override?: string | null): string | null {
    if (override) {
        return override;
    }

    if (!status) {
        return null;
    }

    return STATUS_ICON_MAP[status] ?? null;
}

export interface StatusBadgeHtmlOptions {
    status: string | null | undefined;
    label: string;
    showIcon?: boolean;
    showText?: boolean;
    icon?: string | null;
}

/** Builds static HTML for DevExtreme cells / right-panel innerHTML. */
export function buildStatusBadgeHtml({ status, label, showIcon = true, showText = true, icon }: StatusBadgeHtmlOptions): string {
    const iconClass = showIcon ? getStatusIconClass(status, icon) : null;
    const iconHtml = iconClass ? `<i class="status-badge__icon ${iconClass}" aria-hidden="true"></i>` : '';
    const textHtml = showText ? `<span class="status-badge__label">${escapeHtml(label)}</span>` : '';
    const content = [iconHtml, textHtml].filter(Boolean).join('');

    if (!content) {
        return '';
    }

    return `<span class="badge status app-status-badge ${getStatusIndicatorClass(status)}">${content}</span>`;
}

function escapeHtml(value: string): string {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
